module.exports = __webpack_public_path__ + "img/shop.bbc6182f.png";